;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/apply-member\"},{\"path\":\"/auth/linkedin/callback\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/s";import * as Sentry from "@sentry/nextjs";

Sentry.init({
  dsn: "https://a7d04287c39ff5e1b1b2cbfca1481d40@o4509208259985408.ingest.us.sentry.io/4510850541682688",

  sendDefaultPii: true,

  // 100% in dev, 10% in prod — adjust based on traffic
  tracesSampleRate: process.env.NODE_ENV === "development" ? 1.0 : 0.1,

  // Session Replay: 10% of sessions, 100% of sessions with errors
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  integrations: [Sentry.replayIntegration()],
});

// Required for Next.js 16+ navigation instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

// Capture 4xx HTTP errors from client-side fetch calls
const _originalFetch = globalThis.fetch;
globalThis.fetch = async function sentryFetch(
  ...args: Parameters<typeof globalThis.fetch>
) {
  const response = await _originalFetch(...args);
  if (response.status >= 400 && response.status < 500) {
    const url =
      typeof args[0] === "string"
        ? args[0]
        : args[0] instanceof Request
          ? args[0].url
          : String(args[0]);
    Sentry.captureMessage(`HTTP ${response.status}: ${url}`, {
      level: "warning",
      extra: { status: response.status, url },
    });
  }
  return response;
};
